/* ScaleChart — size-guide placement + option label values.
   Restored to the version that rendered correctly: guide beside the size label,
   "Kleur — Roze" / "Maat — S" values, correct spacing. */
(function () {
  var SIZE_RE = /^(maat|size|taille|gr(ö|oe)sse|größe|talla|taglia|storlek|st(ø|o)rrelse|rozmiar|koko|tamanho)\s*:?\s*$/i;

  function visible(el) {
    return !!(el && el.isConnected && el.offsetParent !== null &&
              (el.offsetWidth > 0 || el.offsetHeight > 0));
  }

  function sizeLabel() {
    var tagged = document.querySelectorAll('[data-sc-label="size"]');
    for (var t = 0; t < tagged.length; t++) if (visible(tagged[t])) return tagged[t];

    var wraps = document.querySelectorAll('.variant-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var fs = wraps[i].querySelector('fieldset.variant-input-wrap');
      var lb = wraps[i].querySelector('label.variant__label');
      if (!fs || !visible(lb)) continue;
      var name = (fs.getAttribute('name') || fs.getAttribute('data-handle') || '').trim();
      var own = (lb.firstChild && lb.firstChild.nodeValue) || '';
      if (SIZE_RE.test(name) || SIZE_RE.test(own.trim())) return lb;
    }
    return null;
  }

  function labelValues() {
    var groups = document.querySelectorAll('[data-sc-variant], .variant-wrapper, fieldset.variant-input-wrap');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      var checked = g.querySelector('input[type="radio"]:checked');
      if (!checked) continue;
      var val = (checked.value || '').trim();
      if (!val) continue;

      var lb = g.querySelector('[data-sc-label]') ||
               g.querySelector('label.variant__label') ||
               g.querySelector('legend:not(.hide)') ||
               (g.parentElement && g.parentElement.querySelector('[data-sc-label], label.variant__label'));
      if (!lb || !visible(lb)) continue;

      var native = lb.querySelector('.variant__label-info, .sc-selected-value');
      if (native && native.offsetParent !== null) continue;
      if (lb.textContent.indexOf('— ' + val) !== -1) continue;

      var span = lb.querySelector('.sc-theme-val');
      if (!span) {
        span = document.createElement('span');
        span.className = 'sc-theme-val';
        var guide = lb.querySelector('[id^="scalechart-app-block-"]');
        if (guide) lb.insertBefore(span, guide); else lb.appendChild(span);
      }
      var txt = ' — ' + val;
      if (span.textContent !== txt) span.textContent = txt;
    }
  }

  function park(wrap) {
    var btn = wrap && (wrap.querySelector('.scalechart-trigger-btn') || wrap.querySelector('button'));
    if (btn && btn.style.visibility !== 'hidden') btn.style.setProperty('visibility', 'hidden', 'important');
  }

  function place() {
    var wrap = document.querySelector('[id^="scalechart-app-block-"]');
    if (!wrap) return false;
    var lb = sizeLabel();
    if (!lb) { park(wrap); return false; }
    if (wrap.parentElement !== lb) { park(wrap); lb.appendChild(wrap); }
    lb.classList.add('sc-has-guide');
    wrap.style.setProperty('display', 'contents', 'important');

    var btn = wrap.querySelector('.scalechart-trigger-btn') || wrap.querySelector('button');
    if (btn && !(btn.style.position === 'static' && btn.style.marginLeft === '20px' && btn.style.visibility === 'visible')) {
      /* Inline: the app writes margin:0 !important inline, which no stylesheet beats. */
      btn.style.setProperty('margin', '0 0 0 20px', 'important');
      btn.style.setProperty('position', 'static', 'important');
      btn.style.setProperty('top', 'auto', 'important');
      btn.style.setProperty('left', 'auto', 'important');
      btn.style.setProperty('right', 'auto', 'important');
      btn.style.setProperty('display', 'inline-flex', 'important');
      btn.style.setProperty('visibility', 'visible', 'important');
      btn.style.setProperty('opacity', '1', 'important');
      btn.style.setProperty('pointer-events', 'auto', 'important');
      var bid = (wrap.id || '').replace('scalechart-app-block-', '');
      if (bid) {
        try { delete window['_sc_pos_' + bid]; } catch (e) { window['_sc_pos_' + bid] = null; }
        try {
          if (window.sc_observers && window.sc_observers[bid] && window.sc_observers[bid].disconnect) {
            window.sc_observers[bid].disconnect();
          }
        } catch (e) { /* not exposed on this version */ }
      }
    }
    return true;
  }

  function boot() {
    labelValues();
    if (place()) return;
    var tries = 0;
    var t = setInterval(function () {
      labelValues();
      if (place() || ++tries > 60) clearInterval(t);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) labelValues();
  }, true);

  var queued = false;
  try {
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; place(); labelValues(); }, 60);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  } catch (e) { /* interval above still covers first paint */ }
})();

/* Main product image follows the colour swatch — REMOVED 2026-09-15.
   This duplicated logic the ScaleChart app now does itself (an exact match
   against the product's real variant/media JSON, fired synchronously from
   the swatch's own change handler) — and this theme-side copy used a
   weaker heuristic (first "_"-separated segment of the image filename).
   For Shopify's own upload naming, "Name_<uuid>.webp", every colour shares
   the same segment before the underscore, so this always matched the FIRST
   thumbnail regardless of which colour was actually selected — and because
   it ran on a setTimeout (60-120ms) AFTER the app's own correct, synchronous
   update, it silently overwrote the right image with the wrong one a moment
   later. Reported on the Kenna/Selara blouse (Rood, Groen, Zwart, Geel all
   snapping back to the Wit photo); the app's own fix supersedes this. */
